export default {
  form: {
    address: {
      label: 'Adres',
      placeholder: 'Adres',
    },
    zip_code: {
      label: 'Postcode',
      placeholder: 'Postcode',
    },
    city: {
      label: 'Stad',
      placeholder: 'Stad',
    },
    start_time: {
      label: 'Starttijd',
      placeholder: 'bijv. 11:00',
    },
    name: {
      label: 'Naam van de locatie (optioneel)',
      placeholder: 'bijv. Naast de Fernsehturm',
      tooltip: 'Een locatienaam invullen helpt klanten de locatie te herkennen, bijv. "Naast de Fernsehturm"',
    },
    note: {
      label: 'Opmerking',
      placeholder: 'Opmerking invoeren',
    },
  },
  buttons: {
    add_location: 'Locatie toevoegen',
  },
};
